import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import { ButtonTxtStyle } from "../Typography";

const StyledLink = styled(Link)`
  &:hover {
    .arrow-svg-wrapper {
      transform: translateX(4px);
    }
    .arrow-group {
      fill: ${({ theme }) => theme.colors.green5};
    }
  }
  &:active {
    .arrow-svg-wrapper {
      transform: translateX(8px);
    }
  }
`;

const LinkText = styled.span`
  ${ButtonTxtStyle}
  color: ${({ theme }) => theme.colors.green4};
  &:hover {
    color: ${({ theme }) => theme.colors.green5};
  }
`;

const ArrowWrapper = styled.span`
  position: absolute;
  margin-left: 8px;
  transition: transform 0.4s ease-out, color 0.4s ease-out;
  .arrow-group {
    transition: fill 0.6s ease-out, color 0.4s ease-out;
  }
`;

const ArrowSvg = styled.svg`
  transition: fill 0.6s ease-out, color 0.4s ease-out;
`;

const ArrowLink = ({ to, linkText, className }) => (
  <StyledLink to={to} className={className}>
    <LinkText className="link-text">{linkText}</LinkText>
    <ArrowWrapper className="arrow-svg-wrapper">
      <ArrowSvg
        width="18px"
        height="12px"
        viewBox="0 0 18 12"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g
            className="arrow-group"
            transform="translate(-988.000000, -343.000000)"
            fill="#2A6F2B"
          >
            <g transform="translate(-1.000000, 0.000000)">
              <g transform="translate(797.000000, 321.000000)">
                <polygon points="204.087089 22 210 28.0004525 204.087089 34 202.8 32.5264831 206.273486 29 192 29 192 27 206.273486 27 202.8 23.4735169" />
              </g>
            </g>
          </g>
        </g>
      </ArrowSvg>
    </ArrowWrapper>
  </StyledLink>
);

export default ArrowLink;
